import axios from "../../axios/index.js";

export default {
    fetchUser(id) {
        return axios.get(`/users/${id}`);
    },
    fetchUsers() {
        return axios.get("/users/");
    },
    addUser(payload) {
        return axios.post("/users/register", payload);
    },
    editUser(payload) {
        return axios.put(`/users/${payload.Id}/edit`, payload);
    },
    deleteUser(id) {
        return axios.delete(`/users/${id}`);
    },
    checkUsername(username) {
        return axios.get(`/users/${username}/username`);
    },
    enableUser(id) {
        return axios.put(`/users/${id}/enable`);
    },
    disableUser(id) {
        return axios.put(`/users/${id}/disable`);
    },
}